module.exports = __webpack_public_path__ + "static/media/linkCard_evs_hover.bb69819b.svg";